import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const RocketChat = forwardRef<SVGSVGElement, SvgIconProps>(
  function ClientAndPatient(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M10.745 12.065c.033 1.866 2.872 1.845 2.855-.024v-.025C13.568 10.137 10.712 10.182 10.745 12.065zM6.221 12.065c.012.783.664 1.41 1.45 1.398.766 0 1.412-.632 1.404-1.424v-.02C9.048 10.142 6.192 10.182 6.221 12.065zM15.269 12.065c.012.783.664 1.41 1.45 1.398.787-.004 1.413-.644 1.405-1.424v-.02C18.096 10.142 15.24 10.182 15.269 12.065z" />
        <path d="M20.267,5.843c-3.206-2.108-7.466-2.588-11.005-1.952C5.303,0.089,0.866,1.836,0,2.34c0,0,3.045,2.576,2.551,4.832c-3.605,3.658-1.892,7.732,0,9.655C3.046,19.082,0,21.659,0,21.659c0.857,0.505,5.282,2.248,9.263-1.534c3.531,0.632,7.791,0.156,11.005-1.957C25.236,15.01,25.253,9.017,20.267,5.843z M12.256,18.148c-1.24,0.004-2.472-0.156-3.67-0.472l-0.824,0.792c-0.457,0.443-0.972,0.824-1.524,1.136c-0.671,0.336-1.404,0.545-2.155,0.611c0.041-0.073,0.078-0.148,0.115-0.217c0.824-1.522,1.047-2.883,0.667-4.093c-1.355-1.062-2.167-2.42-2.167-3.905c0-3.4,4.281-6.156,9.559-6.156s9.559,2.756,9.559,6.156C21.814,15.399,17.534,18.148,12.256,18.148z" />
      </SvgIcon>
    )
  },
)

export default RocketChat
